import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {
  EnvironmentProviders,
  ImportProvidersSource,
  Provider,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  EnvironmentConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  RestService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import {
  CustomRestService,
  CustomServerSettingsService,
} from '@monorepo-projects/alwayson-shared';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { environment } from '../../environments/environment';

export const commonsProvidersFrom: ImportProvidersSource[] = [

  GoogleMapsModule,
  EditorModule,
];

export const commonsProviders: Array<Provider | EnvironmentProviders> = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
  { provide: SettingsService, useClass: CustomServerSettingsService },
  { provide: RestService, useClass: CustomRestService },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
];
